'use client'

import Image from 'next/image'
import { businessCircleTick, businessCircleTick16 } from 'src/businessLandingPageMock'
import styles from './businessRedirect.module.scss'

const BusinessRedirect = data => {
  const { heading, subHeading, ctaText, ctaUrl, ctaPrompts, image } = data?.data?.data
  const onClickRedirect = () => {
    // TODO: Add segment event
    window.location.href = ctaUrl
  }
  return (
    <div className={styles.businessRedirect}>
      <div className={styles.circle1} />
      <div className={styles.circle2} />
      <div className={styles.leftSection}>
        <p className={styles.heading}>{heading}</p>
        <p className={styles.subHeading}>{subHeading}</p>
        <button className={styles.ctaButton} type="button" onClick={onClickRedirect}>
          {ctaText}
        </button>
        <div className={styles.prompts}>
          {ctaPrompts?.map((prompt, index) => (
            <div key={index} className={styles.prompt}>
              <div className={styles.circleTick}>{businessCircleTick}</div>
              <div className={styles.circleTick16}>{businessCircleTick16}</div>
              {prompt}
            </div>
          ))}
        </div>
      </div>
      <div className={styles.rightSection}>
        <Image
          className={styles.image}
          src={image?.data?.attributes?.url}
          alt="Business Redirect"
          width={417}
          height={554}
        />
      </div>
    </div>
  )
}

export default BusinessRedirect
